import classNames from 'classnames'
import { DropdownButton } from 'components/DropdownButton/DropdownButton'
import MessageCenter from 'components/global-nav/components/MessageCenter'
import css from './MessageCenterMenu.scss'

interface MessageCenterMenuProps {
  c6UnifiedSearchPhase0Variant: boolean
}

const MessageCenterMenu = ({
  c6UnifiedSearchPhase0Variant,
}: MessageCenterMenuProps) => {
  const title = (
    <div className="flex-row pull-left">
      <span
        className={classNames(css.bellIcon, {
          [css.GlobalNav__BellIcon]: c6UnifiedSearchPhase0Variant,
        })}
      />
    </div>
  )

  return (
    <DropdownButton
      pullRight
      aria-label="message center"
      bsStyle="nav-link"
      data-testid="message-center"
      id="message-center"
      title={title}
    >
      <li>
        <MessageCenter />
      </li>
    </DropdownButton>
  )
}

export default MessageCenterMenu
